import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import API_URL from '../config/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const storedToken = localStorage.getItem('token');
        if (storedToken) {
            setToken(storedToken);
            // Fetch user data from API
      axios
        .get(`${API_URL}/api/users/me`, {
          headers: { Authorization: `Bearer ${storedToken}` }
        })
                .then((res) => {
                    setUser(res.data);
                })
                .catch((err) => {
                    console.error(err);
                    localStorage.removeItem('token');
                    setToken(null);
                })
                .finally(() => setLoading(false));
        } else {
            setLoading(false);
        }
    }, []);

    const login = async (email, password) => {
  try {
    const response = await axios.post(`${API_URL}/api/auth/login`, { email, password });
    const { token, user } = response.data;

    localStorage.setItem('token', token);
    setToken(token);
    setUser(user);

    return user;  // Return user info
  } catch (err) {
    console.error('Login error response data:', err.response?.data);

    const errors = err.response?.data?.errors;
    if (errors && Array.isArray(errors)) {
      // Combine all validation error messages into one string
      const message = errors.map(e => e.msg).join(', ');
      throw new Error(message);
    } else {
      throw new Error(err.response?.data?.msg || 'Login failed');
    }
  }
};


    const register = async (userData) => {
  try {
    const response = await axios.post(`${API_URL}/api/auth/register`, userData);
    const { token } = response.data;
    localStorage.setItem('token', token);
    setToken(token);
    // Fetch user data
    const fetchedUser = await axios.get(`${API_URL}/api/users/me`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    setUser(fetchedUser.data);
  } catch (err) {
    const errors = err.response?.data?.errors;
    if (errors && Array.isArray(errors)) {
      // Combine all validation error messages into one string
      const message = errors.map(e => e.msg).join(', ');
      throw new Error(message);
    } else {
      throw new Error(err.response?.data?.msg || 'Registration failed');
    }
  }
};


    const logout = () => {
        localStorage.removeItem('token');
        setToken(null);
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, token, login, register, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
